import React from 'react';
import { reduxForm } from 'redux-form';
import PropTypes from 'prop-types';

import Paragraph from '../../Paragraph';
import Heading from '../../Heading';
import Button from '../../Button';

// const validate = (values) => {
//   if (!document.cookie.split(';').filter((item) => item.includes('gdprpolicy=accepted')).length) {
//     document.querySelector('.js-comb-register').click();
//   }
// };

const Exists = props => (
  <fieldset className="justifycentre existing-section">
    <Heading classes="header-text smaller purple" center>This account already exists</Heading>
    <Paragraph classes="width-limited" center>An account already exists with this email and date of birth.</Paragraph>
    <Paragraph classes="width-limited" center>Please <a href="https://www.livewelldorset.co.uk/contact/">contact us</a> to discuss how we can help you.</Paragraph>
    <Paragraph classes="button-groups divideline" center>
      <Button classes={['underline-button']} label="Back" onClick={props.previousPage} />
    </Paragraph>
  </fieldset>
);

Exists.propTypes = {
  previousPage: PropTypes.func.isRequired,
};

export default reduxForm({
  form: 'registration', // <------ same form name
  destroyOnUnmount: false, // <------ preserve form data
  forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
})(Exists);



// WEBPACK FOOTER //
// ./src/Components/Register/FormPages/Exists.jsx